import { createSelector } from 'reselect'

import { MAX_DRIVING_DISTANCE, MAX_NEARBY_DISTANCE, VISIBLE_BY_DEFAULT_PRODUCTION_LISTINGS_LIMIT } from '@/constants'
import type { Production, ProductionListSelectorType } from '@/types/app-types'
import { formatProductionDates, formatVenueLocation } from '@/utils/production'

export const productionListSelectorCreator = (itemsSelector: (state: any) => Production[]) =>
    createSelector(itemsSelector, (productions: Production[]) => {
        return productions.map((production, index) => {
            const productionListing: ProductionListSelectorType = {
                ...formatProductionDates(production),
                ...formatVenueLocation(production.venue),
                venueName: production.venue.name,
                name: production.name,
                id: production.id,
                category: production.categoryId,
                // Prioritize webPath over the deprecated organicUrl
                href: production.webPath || production.organicUrl || '',
                isExternal: true,
                performers: production.performers,
                defaultVisible: index < VISIBLE_BY_DEFAULT_PRODUCTION_LISTINGS_LIMIT,
                ticketCount: production.ticketCount,
                lat: production.venue.latitude,
                long: production.venue.longitude,
                minPrice: production.minPrice,
                maxPrice: production.maxPrice,
                // Venues still use organicUrl for now
                venueUrl: production.venue.organicUrl,
                // TODO: Remove 'venueWebPath' and 'venueOrganicUrl' and use 'venueUrl' instead once 'organicUrl' gets deprecated
                venueWebPath: production.venue.webPath,
                venueOrganicUrl: production.venue.organicUrl,
                isNearByDistance: production.distance !== undefined && production.distance <= MAX_NEARBY_DISTANCE,
                isDriveDistance:
                    production.distance !== undefined &&
                    MAX_NEARBY_DISTANCE <= production.distance &&
                    production.distance <= MAX_DRIVING_DISTANCE,
                // keep the original production object for analytics
                analytics: { production, index },
            }
            return productionListing
        })
    })
